<div>
    <button routerLink="/management/travel-create">Create New</button>
    <div *ngFor="let travelType of travelTypes" routerLink="/management/travel-edit/{{travelType.id}}">
        {{travelType.code}}
    </div>
</div>
